import NewListing from '../../components/Proposal/NewListing/NewListing'
import WithProposalContainer from '../Common/WithProposalContainer'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'

NewListing.fetchData = async ({ store, req, res, match }) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const props = {
  proposalType: PROPOSAL_TYPE.NEW_LISTING
}

const MappedContainer = WithProposalContainer(NewListing, props)

export default MappedContainer
